// jQuery bundle
window.$ = window.jQuery = require('jquery');

// Flatpickr
const flatpickr = require('flatpickr');
const Russian = require('flatpickr/dist/l10n/ru.js').default.ru;
flatpickr.localize(Russian);
window.flatpickr = flatpickr;

// TinyMCE
import tinymce from 'tinymce/tinymce';
window.tinymce = tinymce;

// Required TinyMCE components
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/models/dom';

// TinyMCE plugins (minimal set)
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
